import React from 'react';

interface StatisticCardProps {
  FilteGroup: any[];
  reportsData?: any;
}

export const StatisticCard = ({ FilteGroup, reportsData }: StatisticCardProps) => {
  const getFactoryStatus = (factoryId: string): string => {
    if (reportsData?.data?.[factoryId]?.status) {
      return reportsData.data[factoryId].status;
    }
    return 'Не начато';
  };

  const factoryStatuses: string[] = FilteGroup.map((factory) => getFactoryStatus(factory.id || factory.ID));

  const totalFactories = factoryStatuses.length;
  const completedFactories = factoryStatuses.filter((status) => status === 'Завершено').length;

  const getOverallStatus = () => {
    if (totalFactories === 0 || !FilteGroup.length) {
      return 'Не начато';
    }

    if (factoryStatuses.every((status) => status === 'Завершено')) return 'Завершено';
    if (factoryStatuses.every((status) => status === 'Не начато')) return 'Не начато';
    return 'В процессе';
  };

  const overallStatus = getOverallStatus();

  return (
    <div className='bg-white rounded-lg p-4 w-full shadow-sm'>
      <div className='flex items-center justify-around gap-2 text-sm'>
        <div className='flex items-center gap-2'>
          <span className='text-primary text-sm font-medium'>Статус по стране:</span>
          <div className='flex items-center gap-2'>
            <div className={`w-3 h-3 rounded ${overallStatus === 'Завершено' ? 'bg-[#22AD5C]' : overallStatus === 'В процессе' ? 'bg-[#F2A900]' : 'bg-[#8899A8]'}`} />
            <span className='text-primary text-sm font-normal'>{overallStatus}</span>
          </div>
        </div>
        <div className='w-px h-5 bg-gray-200' />
        <div className='flex items-center'>
          <span className='text-primary text-sm font-medium'>
            Всего заводов: <span className='text-primary text-sm font-normal'>{totalFactories}</span>
          </span>
        </div>
        <div className='w-px h-5 bg-gray-200' />
        <div className='flex items-center'>
          <span className='text-primary text-sm font-medium'>
            Заводов с завершенным статусом: <span className='text-primary text-sm font-normal'>{completedFactories}</span>
          </span>
        </div>
      </div>
    </div>
  );
};
